import { ArrowLeft } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowThinLeft = mkIcon(ArrowLeft);